import React, {Component} from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { Cookies } from 'react-cookie';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

class LearnMore extends Component {
  constructor (props) {
    super(props);
    this.state = {
      url: `${process.env.REACT_APP_API_URL}/services/plan`,
      area: props.area,
      first_name: '',
      last_name: '',
      phone: '',
      company: '',
      email: '',
      county: this.props.Location,
      marketingSource: '',
      formErrors: {},
      success: false,
      submitting: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount () {
    const cookies = new Cookies();
    const MarketingCampaignSource = (cookies.get('CDPHP_Marketing_Campaign_Source')) ? cookies.get('CDPHP_Marketing_Campaign_Source') : 'Not Set';
    this.setState({
      marketingSource: MarketingCampaignSource
    });
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    let formResults;
    let lead;
    if (this.state.area === 'IndividualQuote') {
      formResults = {
        'area': this.state.area,
        'first_name': this.state.first_name,
        'last_name': this.state.last_name,
        'email': this.state.email,
        'phone': this.state.phone,
        'details': this.props.details,
        'Lead_Source__c': this.props.subsidy > 0 ? 'funnel_consumer_quote_exchange_subsidy' : 'funnel_consumer_quote_exchange',
        'last_shown_plan_id': this.props.lastPlanId,
        'Campaign__c': this.state.marketingSource.leadCampaign,
        'Content__c': this.state.marketingSource.leadContent,
        'Medium__c': this.state.marketingSource.leadMedium,
        'Source__c': this.state.marketingSource.leadSource,
        'GCLID__c': this.state.marketingSource.leadGCLID
      };
      lead = 'Consumer';
    }

    if (this.state.area === 'Essential' || this.state.area === 'EssentialCHP') {
      formResults = {
        'area': this.state.area,
        'first_name': this.state.first_name,
        'last_name': this.state.last_name,
        'email': this.state.email,
        'phone': this.state.phone,
        'details': this.props.details,
        'County__c': this.props.details.Location.loc.County,
        'Lead_Source__c': this.props.LeadSource,
        'last_shown_plan_id': this.props.lastPlanId,
        'Campaign__c': this.state.marketingSource.leadCampaign,
        'Content__c': this.state.marketingSource.leadContent,
        'Medium__c': this.state.marketingSource.leadMedium,
        'Source__c': this.state.marketingSource.leadSource,
        'GCLID__c': this.state.marketingSource.leadGCLID
      };
      if (this.state.area === 'EssentialCHP') {
        lead = 'EssentialCHP';
      } else {
        lead = 'Essential';
      }
    }

    if (this.state.area === 'EmployerQuote' || this.state.area === 'EmployerQuoteWinback') {
      formResults = {
        'area': this.state.area,
        'first_name': this.state.first_name,
        'last_name': this.state.last_name,
        'email': this.state.email,
        'phone': this.state.phone,
        'company': this.state.company,
        'County__c': this.props.details.Location.loc.County,
        'Group_Size_Range__c': this.props.details.FullTimeEmployees,
        'details': this.props.details,
        'Lead_Source__c': 'funnel_smallbiz_quote',
        'last_shown_plan_id': this.props.lastPlanId,
        'Campaign__c': this.state.marketingSource.leadCampaign,
        'Content__c': this.state.marketingSource.leadContent,
        'Medium__c': this.state.marketingSource.leadMedium,
        'Source__c': this.state.marketingSource.leadSource,
        'GCLID__c': this.state.marketingSource.leadGCLID
      };
      lead = 'Small Group';
    }

    if (this.state.area === 'MedicareQuote' || this.state.area === 'MedicareQuoteWesternNY') {
      formResults = {
        'area': this.state.area,
        'first_name': this.state.first_name,
        'last_name': this.state.last_name,
        'email': this.state.email,
        'phone': this.state.phone,
        'County__c': this.state.county ? this.state.county.loc.County : this.props.county.County,
        'Preferred_Construct__c': (this.props.details && this.props.details.CostPreference === 1) ? 'Lower Premium' : 'Lower OOP',
        'details': this.props.details,
        'last_shown_plan_id': this.props.lastPlanId,
        'Campaign__c': this.state.marketingSource.leadCampaign,
        'Content__c': this.state.marketingSource.leadContent,
        'Medium__c': this.state.marketingSource.leadMedium,
        'Source__c': this.state.marketingSource.leadSource,
        'GCLID__c': this.state.marketingSource.leadGCLID
      };
      lead = 'Medicare';
    }

    console.log(formResults);
    console.log(this.props.details);

    const errors = this.validateForm(formResults);
    const isDisabled = Object.keys(errors).some(x => errors[x]);
    if (!isDisabled) {
      this.setState({submitting: true});
      axios.post(
        this.state.url, formResults
      ).then(response => {
        console.log(response);
        this.setState({submitting: false});
        this.setState({success: true});
        this.resetForm();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formID': 'Plans Microsite - ' + lead + ' Lead'
        });
      }).catch(error => {
        console.log('Error Message: ' + error);
      });
    } else {
      this.setState({formErrors: errors});
    }
  }

  validateForm = (formResults) => {
    let formErrors = {};

    if (formResults.first_name.length < 2) {
      formErrors.first_name = 'Required';
    }

    if (formResults.last_name.length < 2) {
      formErrors.last_name = 'Required';
    }
    if (this.props.type === 'biz') {
      if (formResults.company.length < 2) {
        formErrors.company = 'Required';
      }
    }
    if (!formResults.phone || formResults.phone.length < 10) {
      formErrors.phone = 'Required';
    } else if (!/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(formResults.phone)) {
      formErrors.phone = 'Invalid phone number';
    }

    if (!formResults.email) {
      formErrors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formResults.email)) {
      formErrors.email = 'Invalid email address';
    }
    return formErrors;
  }

    closeForm = (event) => {
      this.resetForm();
      this.props.closeModal();
      var that = this;
      setTimeout(function () {
        that.setState({
          success: false
        });
      }, 500);
    }

    resetForm = () => {
      console.log('Reset');
      this.setState({
        formErrors: {},
        first_name: '',
        last_name: '',
        email: ''
      });
    }

    trackEnrollment = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'GAEvent',
        'eventCategory': 'Click',
        'eventAction': 'Load Website',
        'eventLabel': 'Go to DRx',
        'eventValue': undefined
      });
    }

    render () {
      let successMessage = this.state.area === 'MedicareQuote' ? 'CDPHP Medicare representative' : 'sales representative';
      let Success = null;
      if (this.state.success) {
        Success = (<div id='success' className={this.state.success ? 'show' : ''}>
          <div>
            <h4>Thanks!</h4>
            <p>A {successMessage} will be in touch.</p>
          </div>
        </div>);
      }

      let Company = null;
      if (this.props.type === 'biz') {
        Company = (
          <p>
            <label>My company is</label>
            <input
              name='company'
              id='company'
              type='text'
              placeholder='Company'
              className={'company ' + (this.state.formErrors.last_name ? 'error' : '')}
              value={this.state.company}
              onChange={this.handleInputChange} />
          </p>
        );
      }

      /* let sendQuoteCheckbox = null;
      if (this.props.MedicareCompare) {
        sendQuoteCheckbox = (
          <p className='inlineCheckBox'>
            <input
              name='sendQuote'
              id='sendQuote'
              type='checkbox'
              checked={this.state.sendQuote}
              className='checkbox'
              onChange={this.handleInputChange} />
            <label htmlFor='sendQuote'>
                Yes, please email me my quote
            </label>
          </p>
        );
      } */

      let medicareClass = null;
      let medicareCallout = null;
      let medicareHeading = null;
      let medicareZip = null;
      const MedicareResults = (this.props.area === 'MedicareQuote');

      if (MedicareResults && !this.props.MedicareCompare) {
        medicareClass = 'medicareForm';
        medicareZip = this.props.details ? this.props.details.ZipCode : this.props.zip;
        medicareHeading = <h3>Want us to call you?</h3>;
        let callOutItem = null;
        let specialEnrollment = null;
        let currentDate = new Date();

        let openEnrollmentStartDate = new Date('10/15/2024');
        let openEnrollmentEndDate = new Date('12/07/2024');

        let nextYearStartDate = new Date('01/01/2025');
        let nextYearEndDate = new Date('03/31/2025');

        if (currentDate > openEnrollmentStartDate && currentDate < openEnrollmentEndDate) {
          callOutItem = <li>Or, if you’re over 65, you can enroll between now and December&nbsp;7</li>;
        } else if (currentDate > nextYearStartDate && currentDate < nextYearEndDate) {
          callOutItem = <li>Or, if you’re over 65, you can enroll between now and March 31 if you’re switching from another Medicare Advantage provider</li>;
        } else {
          const specialContent = (<span>
            <h6>Do you qualify for Special Enrollment?</h6>
            <p className='no-pad'>You may be eligible to enroll in Medicare outside of Open Enrollment if you&rsquo;re in the midst of major life changes, such as leaving a job or moving. There&rsquo;s a 60-day Special Enrollment Period for those events. Contact CDPHP at 1-888-519-7898 to see if you qualify.</p>
          </span>);
          specialEnrollment = <span>&ndash; or you qualify for <Tooltip html={specialContent} arrow='true' unmountHTMLWhenHide='true'><strong className='helpTip'>Special Enrollment</strong></Tooltip></span>;
        }

        if (this.props.planName === 'Flex RX' || this.props.planName === 'Vital RX') {
          medicareCallout = (
            <aside>
              <h3>Enroll any time through November 30!</h3>
              <h4>First, make sure you:</h4>
              <ul>
                <li>Have Medicare Parts A and&nbsp;B</li>
                <li>Are 65 years of age or older</li>
                {callOutItem}
              </ul>
              <p>Then visit our <a href={'https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/PlanList?ZipCode=' + medicareZip + '&AgentID=cdphpfunnel'} target='_blank' rel='noopener noreferrer'
                onClick={this.trackEnrollment}>Secure Medicare Enrollment Site</a>. It’s easy!</p>
            </aside>
          );
        } else {
          medicareCallout = (
            <aside>
              <h3>Ready to enroll?</h3>
              <h4>First, make sure:</h4>
              <ul>
                <li>You have Medicare Parts A and&nbsp;B</li>
                <li>You’re within three months of turning 65 {specialEnrollment}</li>
                {callOutItem}
              </ul>
              <p>Then visit our <a href={'https://cdphpmedicare1.destinationrx.com/PC/2027/Shopping/PlanList?ZipCode=' + medicareZip + '&AgentID=cdphpfunnel'} target='_blank' rel='noopener noreferrer'
                onClick={this.trackEnrollment}>Secure Medicare Enrollment Site</a>. It’s easy!</p>
            </aside>
          );
        }
      }

      let headline = null;
      let phoneLink;

      if (this.props.phone && this.props.phone.indexOf('|') > -1) phoneLink = '866-692-3747';
      else phoneLink = this.props.phone;

      if (!this.props.MedicareCompare) {
        headline = (<div>
          <h4>Interested in the {this.props.planName} plan? Fantastic!</h4>
          <p>Connect with a CDPHP sales representative to learn more about the<br /> plan benefits and discuss any additional needs you may have.</p>
        </div>);
      } else {
        medicareClass = 'compare-form';
        headline = (<div className='compare-headline'>
          <h4>Give us a call or set up an appointment to discuss details, other available plans and to confirm all your doctors and prescriptions are covered.</h4>
          <p><a href={'tel:' + phoneLink}>{this.props.phone}</a></p>
        </div>);
      }

      return (
        <section className={medicareClass}>
          <div className='inlineForm'>
            <div className='wrap sm text-center'>
              <div className={this.state.submitting ? ' loading' : ''}>
                {headline}
                <div className='form-content'>
                  <form onSubmit={this.handleSubmit}>
                    {medicareHeading}
                    <p>
                      <label>My name is</label>
                      <span className='inputContainer'>
                        <input
                          name='first_name'
                          id='first_name'
                          type='text'
                          placeholder='First'
                          className={'first_name ' + (this.state.formErrors.first_name ? 'error' : '')}
                          value={this.state.first_name}
                          onChange={this.handleInputChange} />
                      </span>
                      <span className='inputContainer'>
                        <input
                          name='last_name'
                          id='last_name'
                          type='text'
                          placeholder='Last'
                          className={'last_name ' + (this.state.formErrors.last_name ? 'error' : '')}
                          value={this.state.last_name}
                          onChange={this.handleInputChange} />
                      </span>
                    </p>
                    <p>
                      <label>My phone number is</label>
                      <NumberFormat
                        format='(###) ###-####'
                        mask='_'
                        name='phone'
                        id='phone'
                        type='tel'
                        placeholder='(XXX) XXX-XXXX'
                        className={'phone ' + (this.state.formErrors.phone ? 'error' : '')}
                        value={this.state.phone}
                        onChange={this.handleInputChange}
                      />
                    </p>
                    {Company}
                    <p>
                      <label>My email address is</label>
                      <input
                        name='email'
                        id='email'
                        type='text'
                        className={'email ' + (this.state.formErrors.email ? 'error' : '')}
                        placeholder='you@here.com'
                        value={this.state.email}
                        onChange={this.handleInputChange} />
                    </p>
                    {/* sendQuoteCheckbox */}
                    <p className='pardot_extra_field'>
                      <label htmlFor='pardot_extra_field'>Comments</label>
                      <input type='text' id='pardot_extra_field' name='pardot_extra_field' />
                    </p>

                    <p className='submitForm'>
                      <input type='submit' value='Contact Me' className='btn' />
                    </p>
                  </form>
                  {medicareCallout}
                </div>
                {Success}
              </div>
            </div>
          </div>
        </section>
      );
    }
}

export default LearnMore;
